import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IAutenticacaoState {
  autenticado: boolean;
  usuario: string;
  token: string;
  refresh_token: string;
}

const initialState: IAutenticacaoState = {
  autenticado: false,
  usuario: '',
  token: '',
  refresh_token: '',
};

const stock = createSlice({
  name: 'Autenticacao',
  initialState,
  reducers: {
    salvarSessao(
      state,
      action: PayloadAction<{ usuario: string; token: string; refresh_token: string }>
    ) {
      state.autenticado = true;
      state.usuario = action.payload.usuario;
      state.token = action.payload.token;
      state.refresh_token = action.payload.refresh_token;
    },
    finalizarSessao(state) {
      state.autenticado = false;
      state.usuario = '';
      state.token = '';
      state.refresh_token = '';
    },
  },
});

export const { salvarSessao, finalizarSessao } = stock.actions;

export default stock.reducer;
